<template>
  <v-col ref="col" :cols="width" data-testid="so-col">
    <slot></slot>
  </v-col>
</template>

<script lang="ts">
  import { defineComponent, PropType } from "vue"

  type NumberRange = 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8 | 9 | 10 | 11 | 12

  export default defineComponent({
    props: {
      defaultWidth: {
        type: Number as PropType<NumberRange>,
        default: null,
      },
      lgAndDownWidth: {
        type: Number as PropType<NumberRange>,
        default: null,
      },
      mobileWidth: {
        type: Number as PropType<NumberRange>,
        default: null,
      },
    },
    computed: {
      width() {
        if (this.$vuetify.display.mobile) {
          return this.mobileWidth
        }
        if (this.$vuetify.display.lgAndDown && this.lgAndDownWidth) {
          return this.lgAndDownWidth
        }
        return this.defaultWidth
      },
    },
  })
</script>
